import styled from 'styled-components';
import { getColor, getColorShade, getSizeBy, getElevation, getThemeProp } from '../../../src/styled/utils';
import { Body1Styles, CaptionStyles, Subtitle2Styles } from '../typography';
import Preview from './preview-image';
export const WidgetPreviewWrapper = styled.div `
  display: flex;
  width: 340px;
  height: 112px;
  padding: 12px;
  background-color: ${getColor('surface')};
  border: 1px solid ${getColorShade('onSurface', 'border')};
  border-radius: ${getThemeProp('widgetsBorderRadius')}px;
  box-shadow: ${getElevation(1)};
`;
export const WidgetPreviewInfo = styled.div `
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  margin-left: 12px;
`;
export const WidgetPreviewName = styled.span `
  color: ${getColorShade('onSurface', 'highEmphasis')};
  word-break: break-all;
  ${Body1Styles}
`;
export const WidgetPreviewType = styled.span `
  margin-top: 8px;
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  font-size: 11px;
  word-break: break-all;
  ${CaptionStyles}
`;
export const WidgetPreviewDescription = styled.span `
  margin-top: 8px;
  overflow: hidden;
  color: ${getColorShade('onSurface', 'lowEmphasis')};
  font-size: ${getSizeBy(3)};
  line-height: 16px;
  ${Subtitle2Styles}
`;
export const WidgetPreviewImageFallback = styled(Preview) `
  display: flex;
  flex-shrink: 0;
  width: 102px;
  height: 88px;
  border: 0.5px solid ${getColorShade('onSurface', 'border')};
  border-radius: 6px;
`;
